import * as React from "react";
import type { SVGProps } from "react";
const SvgMailOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      d="M2 16q-.824 0-1.412-.588A1.93 1.93 0 0 1 0 14V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h16q.824 0 1.413.588Q20 1.175 20 2v12q0 .825-.587 1.412A1.93 1.93 0 0 1 18 16zm8-7L2 4v10h16V4zm0-2 8-5H2zM2 4V2v12z"
    />
  </svg>
);
export default SvgMailOutline;
